<template>
    <div class="posts-wrapper">
      <div class="packages memberships">
        <!-- <div class="filters">
          <div class="title">Búsqueda</div>
          <div class="wrap-filter">
              <div class="item">
                <label for="">Fechas</label>
                <v-date-picker mode="range" v-model="dateFilter" locale="es" :popover="{ placement: 'top', visibility: 'click' }"></v-date-picker>
              </div>
              <div class="item btnFilter">
                  <vs-button id="btnFilter" class="vs-con-loading__container"  color="primary" type="border" icon="search" @click="searchPackages()">Filtrar</vs-button>
              </div>
          </div>
        </div> --> 
        <div class="box-white-wrapper" v-if="memberships.length > 0">
          <vs-table :data="memberships" pagination max-items="50" :key="keyPackages" search>
              <template slot="thead">
                  <vs-th sort-key="period">Periodo</vs-th>
                  <vs-th sort-key="month">Mes</vs-th>
                  <vs-th sort-key="begDate">Fecha Inicio</vs-th>
                  <vs-th sort-key="endDate">Fecha Cierre</vs-th>
                  <vs-th sort-key="totalPounds">Cant Libras</vs-th>
                  <vs-th sort-key="totalAmount">CashBox</vs-th>
                  <vs-th sort-key="statusName">Estado</vs-th>
                  <vs-th sort-key="id" class="width-30"></vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].period">{{data[indextr].period}}</vs-td>
                    <vs-td :data="data[indextr].month">{{ months[data[indextr].month - 1] }}</vs-td>
                    <vs-td :data="data[indextr].begDate"> {{ data[indextr].begDate | moment('DD/MM/YYYY')}}</vs-td>
                    <vs-td :data="data[indextr].endDate"> {{ data[indextr].endDate | moment('DD/MM/YYYY')}}</vs-td>
                    <vs-td :data="data[indextr].totalPounds"> {{ data[indextr].totalPounds }}</vs-td>
                    <vs-td :data="data[indextr].totalAmount"> ${{ data[indextr].totalAmount }}</vs-td>
                    <vs-td :data="data[indextr].statusName" :class="`pilled p-${data[indextr].st01Code}`"> 
                      {{ data[indextr].totalPounds > 0 ? data[indextr].statusName : 'No Aplica'}}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions">
                              <router-link :to="`/cashback/detail/${data[indextr].id}`"><feather type="eye"/></router-link>
                              <a href="javascript:void(0)" @click="openBill(data[indextr].payFile)" v-if="data[indextr].payFile != null">
                                <feather type="file-text"/>
                              </a>
                        </div>
                    </vs-td>                   
                  </vs-tr>
              </template>
          </vs-table>
           <vue-easy-lightbox escDisabled :moveDisabled="false" :visible="visible" :imgs="imgs" @hide="handleHide"></vue-easy-lightbox>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import VueEasyLightbox from 'vue-easy-lightbox'
import MembershipService from "@/services/MembershipService"
export default {
    name: 'MembershipsView',
    mixins: [helper],
    components: {VueEasyLightbox},
    data () {
        return {
            visible: false,
            textarea: "",
            keyPackages: 0,
            noLimit: false,
            typeChangeSt: false,
            Roles: [],
            boxActive: null,
            keyword: "",
            dateFilter: "",
            filterObj: {
                dateFilter: null,
                status: null,
                filter: ""
            },
            memberships: [],
            imgs: '',  // Img Url , string or Array of string
            months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        }
    },
    created(){
        this.Roles = Role
        this.$Progress.start();
        if(this.userInfoData.customerType != '03'){
            this.$router.push('/')
        }
        this.getResumeMemberships()
        this.$Progress.finish()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    methods: {
    
        async getResumeMemberships () {
            let response = await MembershipService.getCasbackFranchise()
            console.log(response)
            if((response.status / 100) == 2) {
                this.memberships = response.data.data
            }
        },
        openBill (bill) {
          this.imgs = (bill);
          this.visible = true;
        },
        handleHide() {
          this.imgs = "";
          this.visible = false
        },
    }
}
</script>
